// Only what en-AU says differently; every other string is en-US (mergeLocaleResources).
export const auth = {
  login: {
    signingIn: "Signing in…",
    embedSsoHint: "This portal signs you in with your organisation's Microsoft account.",
  },
  signup: {
    subtitle: "Join AssetWRX to get started",
    firstName: "First name",
    firstNamePlaceholder: "Sam",
    lastName: "Last name",
    lastNamePlaceholder: "Taylor",
    rolePlaceholder: "Inspector",
    confirmPassword: "Confirm password",
    successCheckEmail: "Account created. Check your email to confirm your account, then sign in.",
    wizard: {
      workspaceBody: "This is your organisation space in AssetWRX. You can rename it later in settings.",
    },
  },
  forgot: {
    sending: "Sending…",
  },
  reset: {
    updating: "Updating…",
    loading: "Loading…",
  },
} as const;
